export const sumAverageForPeriod = ({
  array,
  keys,
}: {
  array: { [key: string]: string | number }[];
  keys: [string, string, string, string];
}) => {
  const periodRecord = new Map();

  array.forEach(item => {
    const period = `${item.year} ${item.quarter}`;
    const existingPeriod = periodRecord.get(period);

    if (existingPeriod) {
      existingPeriod[keys[2]] += item[keys[2]];
      existingPeriod[keys[3]] += item[keys[3]];
    } else {
      periodRecord.set(period, {
        [keys[0]]: item[keys[0]],
        [keys[1]]: item[keys[1]],
        [keys[2]]: item[keys[2]],
        [keys[3]]: item[keys[3]],
      });
    }
  });

  return Array.from(periodRecord.values());
};
